import React from "react";
import { Flex, Menu, message } from "antd";
import { SoundOutlined, PhoneOutlined, LogoutOutlined, NumberOutlined, UserOutlined, SafetyCertificateOutlined, ShareAltOutlined, TagOutlined, SafetyOutlined, KeyOutlined } from "@ant-design/icons";
import { registerPush } from './notification';
import UpdatePassword from "./update-password";
import clipboard from "../../utils/clipboard";
import {getCurrentShopId} from "../shop/get-current-shop";
import { safeCall } from "../../utils/jsbridge"; // 添加这一行

const MyProfile = () => {
  const [profile, setProfile] = React.useState({});
  const [openUpdatePassword, setOpenUpdatePassword] = React.useState(false);

  const onUpdatePasswordClose = () => {
    setOpenUpdatePassword(false);
  };

  React.useEffect(() => {
    getAccountDetail();
  }, []);
  const sub = () => {
    Notification.requestPermission(result => {
      if (result === 'granted') {
        registerPush().then(res => {
          console.log(res);
          if(res) {
            message.success('订阅成功');
          }else{
            message.error('订阅失败');
          }
        });
      }
    });
  };

  const getAccountDetail = async () => { 
    const response = await fetch('/api/account/detail');
    const result = await response.json();

    if (result && result.success) {
      setProfile(result.data);
    }
  };

  const memuItems = [
    {
      key: '1',
      icon: <NumberOutlined />,
      label: `系统版本：${profile?.version?.title}`,
    },
    { type: 'divider' },
    {
      key: 'type',
      icon: <TagOutlined />,
      label: `账户类型：${profile?.type === 1  ? '个人' : '企业'}`,
    },
    { type: 'divider' },
    {
      key: '2',
      icon: <UserOutlined />,
      label: `主体名称：${profile?.companyName || profile?.realname}`,
    },
    { type: 'divider' },
    {
      key: '3',
      icon: <SoundOutlined />,
      label: '通知订阅 (可接收订单通知等)',
      onClick: sub,
    },
    { type: 'divider' },
    {
      key: '4',
      icon: <PhoneOutlined />,
      label: '联系客服',
      onClick: () => { safeCall('16657132266') },
    },
    { type: 'divider' },
    {
      key: 'invite',
      icon: <ShareAltOutlined />,
      label: '邀请入驻优选到家(可获得被邀请者的订单分佣)',
      onClick: async () => { clipboard(`https://yxdj.tech/regist?shopId=${await getCurrentShopId()}&userId=${window.__baseInfo.userId}`, '邀请链接已复制，发送给你的邀请对象即可。') },
    },
    { type: 'divider' },
    {
      key: 'update-password',
      icon: <KeyOutlined />,
      label: '修改密码',
      onClick: () => setOpenUpdatePassword(true),
    },
    { type: 'divider' },
    {
      key: '5',
      icon: <SafetyOutlined />,
      label: '隐私政策',
      onClick: () => {
        window.location.href = 'https://www.yxdj.tech/privacy-policy.html';
      }
    },
    { type: 'divider' },
    {
      key: '6',
      icon: <LogoutOutlined />,
      label: '退出登录',
      onClick: () => {
        // 删除sessionStorage
        sessionStorage.clear(true);
        window.location.href = '/logout';
      }
    }
  ]

  return (
    <div>
      <h2>我的账户</h2>
      <UpdatePassword onCancel={onUpdatePasswordClose} isOpen={openUpdatePassword} />
      <Menu items={memuItems} selectable={false} />
      {/* <div>版本：{profile?.version?.title}</div>
      <div><a onClick={sub}>订阅通知</a></div>
      <a href="/logout">退出</a> */}
    </div>
  );
};

export default MyProfile;